import { Button } from 'reactstrap';
import { IntlType } from '../../../../utils/typing';

interface Props {
  intl: IntlType;
  handleClick: () => void;
}

const ClearFieldsButton = (props: Props): JSX.Element => {
  const { intl, handleClick } = props;

  return (
    <Button className="submit-button delete" color="secondary" onClick={handleClick}>
      <i className="icon icon-trash"></i> {intl.formatMessage({ id: 'clearFields' })}
    </Button>
  );
};

export default ClearFieldsButton;
